<template>
  <!-- RQ "Add Discount" (Android PromoCodeScreenFragment): discount amount in $ + the order's discount requests -->
  <div ref="rqDiscountModal" class="modal fade" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body !p-3 !pb-0 font-roboto flex flex-col">
          <FxModalHeader title="Add Discount" />

          <div class="flex-1 flex flex-col gap-[12px] px-[6px] pt-[12px]">
            <p class="m-0 text-[14px] text-[#666666]">Please enter additional discount amount</p>
            <div>
              <span class="uqcLabel">Discount ($)</span>
              <inputComponent v-model="discount" placeholder="$" inputmode="decimal" :custom-class="fieldClass" />
            </div>

            <div v-for="d in discounts" :key="d.id"
              class="flex flex-col gap-[4px] p-[10px] rounded-[8px] border border-[#E1E5EF] text-[14px] text-[#333333]">
              <div class="flex items-center justify-between gap-[10px]">
                <span class="text-[12px] text-[#999999]">{{ formatDate(d.created_at) }}</span>
                <button v-if="(d.status_text || '').toLowerCase() === 'pending'" type="button"
                  class="border-0 bg-transparent p-0 text-[14px] font-medium text-[#EE5851] underline"
                  @click="cancel(d)">
                  Cancel
                </button>
              </div>
              <div><span class="text-[#666666]">Id : </span><span class="text-[#7695FF]">{{ d.id }}</span></div>
              <div><span class="text-[#666666]">Status : </span>{{ d.status_text }}</div>
              <div><span class="text-[#666666]">Discounted Amount : </span>$ {{ d.amount }}</div>
            </div>
          </div>

          <div class="uqcFooter flex items-center justify-end gap-[10px]">
            <button type="button" class="uqcBtnCancel" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="uqcBtnNext" @click="apply">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import moment from "moment";
import { useToast } from "vue-toastification";
import FxModalHeader from "../nest_components/FxModalHeader.vue";
import inputComponent from "../partialComponent/inputComponent.vue";
import { rqApi } from "@/services/rqApi";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";

const toast = useToast();

export default {
  components: { FxModalHeader, inputComponent },
  props: {
    orderId: { type: [Number, String], required: true },
  },
  emits: ["changed"],
  data() {
    return {
      discount: "",
      discounts: [],
      fieldClass: "!h-[40px] !px-[12px] !rounded-[8px] !border-[#E1E5EF] !text-[14px] !text-[#333333]",
    };
  },
  mounted() {
    this.bsModal = new Modal(this.$refs.rqDiscountModal, { backdrop: "static", keyboard: false });
    this.$refs.rqDiscountModal.addEventListener("hidden.bs.modal", enableScroll);
  },
  beforeUnmount() {
    this.$refs.rqDiscountModal?.removeEventListener("hidden.bs.modal", enableScroll);
    this.bsModal?.dispose();
  },
  methods: {
    async open() {
      const res = await rqApi.discounts(this.orderId);
      if (!res.ok) return toast.error(res.message || "Unable to load discounts.");
      this.discount = "";
      this.discounts = Array.isArray(res.body) ? res.body : [];
      disableScroll();
      this.bsModal.show();
    },
    // created_at is a unix timestamp (PromoCode::getCreatedAtAutoAttribute)
    formatDate(ts) {
      return ts ? moment.unix(Number(ts)).format("MM/DD/YYYY hh:mm A") : "";
    },
    async apply() {
      const discount = String(this.discount || "").replace(/[$,\s]/g, "");
      if (!discount) return toast.error("Discount Field Required!");
      if (!(Number(discount) > 0)) return toast.error("Please enter a valid discount amount.");
      // Android: promo_code = "fyx-{user_id}" (apply2 builds its own code server side, sent for parity)
      const userId = JSON.parse(localStorage.getItem("user") || "null")?.user?.user_id;
      const res = await rqApi.applyDiscount(this.orderId, discount, `fyx-${userId}`);
      if (!res.ok) return toast.error(res.message || "Unable to apply the discount.");
      this.discounts = Array.isArray(res.body) ? res.body : [];
      this.discount = "";
      toast.success(res.message || "Discount has been applied successfully.");
      this.$emit("changed");
    },
    cancel(d) {
      this.$dialog.show({
        title: "Alert",
        text: "Are you sure you want to cancel?",
        buttonText: "Yes",
        onConfirm: async () => {
          const res = await rqApi.cancelDiscount(this.orderId, d.id);
          if (!res.ok) return toast.error(res.message || "Unable to cancel the discount.");
          this.discounts = Array.isArray(res.body) ? res.body : [];
          this.$emit("changed");
        },
      });
    },
  },
};
</script>
